// The walnut rim, inner band and felt fills (Figma `Table surface` 393:163),
// shared by the board's TableSurface and Share's LiveMedallion. Each takes
// the theme's wood and felt ramps, so a palette change reaches both.

/** Gradient defs with ids `${id}-walnut`, `${id}-band` and `${id}-felt`. */
export function TableGradients({ id }: { id: string }) {
  return (
    <>
      <linearGradient id={`${id}-walnut`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="var(--spades-grad-wood-1)" />
        <stop offset="0.2" stopColor="var(--spades-grad-wood-2)" />
        <stop offset="0.55" stopColor="var(--spades-grad-wood-3)" />
        <stop offset="1" stopColor="var(--spades-grad-wood-4)" />
      </linearGradient>
      <linearGradient id={`${id}-band`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="var(--spades-grad-wood-alt-1)" />
        <stop offset="0.15" stopColor="var(--spades-grad-wood-alt-2)" />
        <stop offset="0.55" stopColor="var(--spades-grad-wood-alt-3)" />
        <stop offset="1" stopColor="var(--spades-grad-wood-alt-4)" />
      </linearGradient>
      <radialGradient id={`${id}-felt`}>
        <stop offset="0" stopColor="var(--spades-grad-felt-1)" />
        <stop offset="0.6" stopColor="var(--spades-grad-felt-2)" />
        <stop offset="1" stopColor="var(--spades-grad-felt-3)" />
      </radialGradient>
    </>
  );
}

/** The bevel's highlight, the felt's dark edge and the gold stitching. */
export const TABLE_BEVEL = 'var(--spades-wood-shine)';
export const TABLE_FELT_EDGE = 'var(--spades-wood-deep)';
export const TABLE_STITCHING = 'var(--spades-gold-amber)';
